import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import APP_ISSUES from './compiled/issues.json';
import './compiled/ViewForm.css';
import Form from './Form';

export default function ViewForm(props) {
  // Index all issues by their key
  const issueIndex = useMemo(
    () =>
      APP_ISSUES.issues.reduce(
        (index, issue) => ({ ...index, [getIssueKey(issue)]: issue }),
        {}
      ),
    []
  );

  const [issueKey, setIssueKey] = useState();
  const issue = useMemo(() => issueIndex[issueKey], [issueIndex, issueKey]);

  return (
    <div className="ViewForm col flex-1">
      <div className="form-header">
        <div className="container">
          <p>{props.form_help}</p>
        </div>
      </div>
      <div className="section flex-1">
        <div className="container">
          <IssuePicklist setValue={setIssueKey} />
          {issue && (
            <div className="issues-content">
              <ReactMarkdown>{issue.description}</ReactMarkdown>
            </div>
          )}
          {issue && <ViewFormFields {...props} issue={issue} />}
        </div>
      </div>
    </div>
  );
}

function ViewFormFields(props) {
  return (
    <Form
      fields={props.fields}
      issue={props.issue}
      history={props.history}
      disableAutofocus={true}
    />
  );
}

function IssuePicklist({ setValue }) {
  // Group all issues by their category to show in different sections in the drop down
  const issueGroups = useMemo(
    () =>
      APP_ISSUES.issues.reduce((groups, issue) => {
        const group = groups[issue.category] || [];
        groups[issue.category] = [...group, issue];
        return groups;
      }, {}),
    []
  );

  const options = useMemo(
    () =>
      Object.entries(issueGroups).map(([groupName, issues]) => (
        <optgroup key={groupName} label={groupName}>
          {issues.map((issue) => (
            <option key={issue.name} value={getIssueKey(issue)}>
              {issue.name}
            </option>
          ))}
        </optgroup>
      )),
    [issueGroups]
  );

  const pleaseSelectVal = '-1';
  const selectRef = useRef(null);

  useEffect(() => {
    // check on load if a previous value was selected
    // and, if so, update the state
    window.setTimeout(() => {
      const elt = selectRef.current;
      const val = elt.value;
      if (val && val !== pleaseSelectVal) {
        setValue(val);
      }
    }, 10);
  }, []);

  return (
    <select
      ref={selectRef}
      className="issues-select"
      onChange={(e) => setValue(e.currentTarget.value)}
    >
      <option value={pleaseSelectVal}>Please select an issue:</option>
      {options}
    </select>
  );
}

function getIssueKey(issue) {
  return issue.name;
}
